module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"locale","languages":["be_nl","be_fr","fi_fi","nl_nl","en"],"defaultLanguage":"en","redirect":false,"i18nextOptions":{"nsSeparator":false}},
    }]
